/* eslint-disable no-unused-vars */

import { useNavigate } from "react-router-dom";
import { api } from "../../api/api";
import { useState, useEffect } from "react";

import { CiMail } from "react-icons/ci";
import { LuArrowRight, LuArrowLeft } from "react-icons/lu";
import { CgSpinnerTwo } from "react-icons/cg";
import { FaRegCircleCheck } from "react-icons/fa6";

import { Toast } from "../../utils/Toast"

import './style.css'

export function RecoverPasswordPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('')
  const [emailWasSent, setEmailWasSent] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const sendPasswordRecordery = async () => {
    try {
      setIsLoading(true)

      await api.post('/users/reset-password', { email })
      setEmailWasSent(true)
    } catch (error) {
      Toast.warning(error?.response?.data?.message, 3000)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    return () => {
      setEmailWasSent(false)
      setIsLoading(false)
    }
  }, [])

  return (
    <div className="container-recover-password">
      <div className="left-area">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <div className="content-img-recover-password">
            <img className="logo-recover-password" src="./logo-sem-fundo.png" alt="Logo Unledu" />
          </div>

          <p style={{ margin: 0, fontWeight: 'bold', fontSize: '2rem', color: 'white' }}>Unledu</p>
        </div>

        <div>
          <p style={{ marginBottom: '1.5rem', fontWeight: 'bold', fontSize: '3.5rem', color: 'white', lineHeight: 1.2 }}> Recupere o acesso à sua conta</p>
          <p style={{ marginBottom: '1.5rem', width: '60%', fontSize: '1.3rem', lineHeight: 1.4, color: '#e9e9e9' }}>Enviaremos um link para seu e-mail cadastrado para você criar uma nova senha.</p>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '1rem', marginTop: '2rem' }}>
            <div style={{ borderRadius: '15px', backgroundColor: '#fd6b33', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.5rem 0.8rem' }}>
              <p style={{ margin: 0, fontWeight: '600', fontSize: '1rem', color: 'white' }}>Processo seguro</p>
            </div>

            <div style={{ borderRadius: '15px', backgroundColor: '#fd6b33', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.5rem 0.8rem' }}>
              <p style={{ margin: 0, fontWeight: '600', fontSize: '1rem', color: 'white' }}>Link temporário</p>
            </div>

            <div style={{ borderRadius: '15px', backgroundColor: '#fd6b33', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.5rem 0.8rem' }}>
              <p style={{ margin: 0, fontWeight: '600', fontSize: '1rem', color: 'white' }}>Suporte 24h</p>
            </div>
          </div>
        </div>

        <div>
          <p style={{ margin: 0, fontSize: '1rem', lineHeight: 1, color: '#ffffff9c', fontWeight: 'bold' }}>© 2026 Unledu. Todos os direitos reservados.</p>
        </div>
      </div>

      <div className="right-area">
        <div style={{
          maxWidth: '400px',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
          {!emailWasSent && (
            <div style={{ marginBottom: '32px' }}>
              <p style={{ marginBottom: '0.7rem', fontWeight: 'bold', fontSize: 'var(--font-size-page-title)', color: 'black', lineHeight: 1.2 }}>Recuperar senha</p>
              <p style={{ fontSize: 'var(--font-size-subtitle)', lineHeight: 1.4, color: '#616161' }}>Digite seu e-mail cadastrado e enviaremos um link para redefinir sua senha</p>
            </div>
          )}

          <div style={{
            zIndex: 10,
            width: '100%',
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
            borderRadius: 15,
            boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',

            ...(emailWasSent && {
              padding: '3rem 2rem',
            })
          }}>
            {!emailWasSent ? (
              <div style={{ width: '100%' }}>
                <div className="mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label" style={{ fontSize: 12, fontWeight: 'bold', color: '#3b3b3b' }}>E-mail</label>

                  <div className="content-input">
                    <div style={{ width: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute' }}>
                      <CiMail size={20} />
                    </div>

                    <input type="email" placeholder="seu@email.com" onChange={(e) => setEmail(e.target.value)} value={email} className="form-control default-input-login" id="exampleInputEmail1" aria-describedby="emailHelp" />
                  </div>
                </div>

                <button
                  className="btn btn-lg btn-dark-blue w-100"
                  style={{
                    height: '40px',
                    borderRadius: '8px',
                    fontWeight: '600',
                    color: 'white',
                    lineHeight: 1.2,
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                    marginTop: '0.8rem',

                    ...(isLoading && {
                      opacity: 0.7,
                      cursor: 'default',
                      pointerEvents: 'none'
                    })
                  }}
                  onClick={sendPasswordRecordery}> {
                    isLoading ? (
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.3rem' }}>
                        <CgSpinnerTwo size={17} className="spinner-rotate" />

                        <p> Enviando...</p>
                      </div>
                    ) : (
                      <>
                        Enviar link de recuperação <LuArrowRight style={{ marginLeft: '0.5rem' }} />
                      </>
                    )}
                </button>
              </div>
            ) : (
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '2rem' }}>
                <div style={{ width: 50, height: 50, backgroundColor: '#05ce0536', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <FaRegCircleCheck size={31} color="#228f22" />
                </div>

                <div>
                  <p style={{ marginBottom: '0.7rem', fontWeight: '600', fontSize: 'var(--font-size-modal-title)', color: 'black', lineHeight: 1.2, textAlign: 'center' }}>E-mail enviado</p>
                  <p style={{ fontSize: '1rem', lineHeight: 1.4, color: '#616161', textAlign: 'center' }}>Enviamos um link de recuperação para <strong style={{ color: '#303030' }}>{email}</strong></p>

                  <p style={{ fontSize: 'var(--font-size-subtitle)', lineHeight: 1.4, color: '#616161', textAlign: 'center', margin: '1.3rem 0 1rem 0' }}>Verifique sua caixa de entrada e spam. O link expira em 30 minutos.</p>
                </div>

                <button
                  className="btn btn-lg btn-dark-blue w-100"
                  style={{
                    height: '40px',
                    borderRadius: '8px',
                    fontWeight: '600',
                    color: 'white',
                    lineHeight: 1.2,
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                  }}
                  onClick={() => setEmailWasSent(false)}
                >
                  Enviar novamente
                </button>

                <div onClick={() => navigate('/')} style={{ display: 'flex', alignItems: 'center', color: '#d95700', cursor: 'pointer', fontWeight: '500', fontSize: 'var(--font-size-subtitle)' }}>
                  <LuArrowLeft style={{ marginRight: '0.5rem' }} size={13} />
                  <p className='m-0 p-0' >Voltar para o login</p>
                </div>
              </div>
            )}
          </div>

          {!emailWasSent && (
            <div onClick={() => navigate('/')} style={{ display: 'flex', alignItems: 'center', color: 'gray', margin: '4rem 0', cursor: 'pointer', fontWeight: '500', fontSize: 'var(--font-size-subtitle)' }}>
              <LuArrowLeft style={{ marginRight: '0.5rem' }} size={13} />
              <p className='m-0 p-0'>Voltar para o login</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
